import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslocoPipe } from '@jsverse/transloco';
import { FontawesomeService } from '../../../services/fontawesome.service';
import { JobsService } from '../../../services/jobs.service';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  imports: [FaIconComponent, TranslocoPipe],
})
export class PaginatorComponent {
  public readonly fontawesomeService = inject(FontawesomeService);
  public readonly jobsService = inject(JobsService);

  @Input() length: number = 0;
  @Output() page = new EventEmitter<number>();
  private itemsPerPage = 25;

  get pageStart(): number {
    return this.jobsService.currentFilter.pageIndex * this.itemsPerPage + 1;
  }

  get pageEnd(): number {
    if (this.reachedEnd) return this.length;
    return (this.jobsService.currentFilter.pageIndex + 1) * this.itemsPerPage;
  }

  get reachedEnd(): boolean {
    return (this.jobsService.currentFilter.pageIndex + 1) * this.itemsPerPage >= this.length;
  }

  next() {
    if (this.reachedEnd) return;
    this.page.emit(this.jobsService.currentFilter.pageIndex + 1);
  }

  prev() {
    if (this.jobsService.currentFilter.pageIndex <= 0) return;
    this.page.emit(this.jobsService.currentFilter.pageIndex - 1);
  }
}
